import { Component, OnInit,Inject } from '@angular/core';
import { GlobalService } from '../../../../global.service';
import { Service } from '../../../../services';
import { LoadingScreenService } from '../../../../services/loading-screen/loading-screen.service';
import {MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA  } from '@angular/material';

@Component({
  selector: 'app-popup-gift-accepted',
  templateUrl: './popup-gift-accepted.component.html',
  styleUrls: ['./popup-gift-accepted.component.sass']
})
export class PopupGiftAcceptedComponent implements OnInit {
  public token: string = sessionStorage.getItem("token");
  public selectBan;
  public gui;
  public nameSend;
  public giftMessage;
  constructor(private loadingScreenService: LoadingScreenService,public matDialogRef:MatDialogRef<PopupGiftAcceptedComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private services: Service, private global: GlobalService) {
     
    if(data.Message!=undefined){
      this.giftMessage=data.Message;
    }
    if(data.NameSender!=undefined){
      this.nameSend=data.NameSender;
    }
    if(data.GUI!=undefined){
      this.gui=data.GUI;
    }
    if(data.BANReceiver!=undefined){
      this.selectBan=data.BANReceiver;
    }
   }

  ngOnInit() {
  }
  acceptGift(){
    if(this.global.validateSession()===true){     
      this.close();  
      this.loadingScreenService.startLoading();
        this.services.GetGift1GBByGUI(this.gui).subscribe(data=> {
            this.loadingScreenService.stopLoading();
            if (data.HasError === false) {
              this.global.notif("Mensaje: Se ha agregado a tu cuenta 1GB de Data.");
            }
            else {
                this.global.notif(data.ErrorDesc);          
            }
        });
    }
  }
  public close(){
    this.matDialogRef.close('cancel');
  }
}
